import { PostRequest } from '@/util/http';

export function APIFetchTrafficPrediction(params: any) {
  return PostRequest('kpi/prediction/traffic', params);
} // APIFetchTrafficByWeek
